import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import { selectores, history, componentToRx, fa } from "app/main/std";
import { ReceptorFactura } from "../../../facturas/edit/componentes/receptorfactura";

interface Props {
    value: models.RepDTO;
}

const facRelCols: kea.Grid2Column<models.FacturaRelacionadaRepDto>[] = [
    kea.columnaBotones([
        {
            iconClass: fa("eye"),            
            onClick: x => history.go("operativa/facturas/" + x.IdRegistro)
        }
    ]), {
        title: "Factura",
        cell: x => ({ data: x.FolioFactura })
    }, {
        title: "No. parcialidad",
        cell: x => ({ data: x.NumParcialidad })
    }, {
        title: "Importe abonado",
        cell: x => ({ data: x.ImportePagado, view: kea.formatCurrency })
    }, {
        title: "Saldo ant",
        cell: x => ({ data: x.ImporteSaldoAnt, view: kea.formatCurrency })
    }, {
        title: "Saldo post.",
        cell: x => ({ data: x.SaldoDespuesPago, view: kea.formatCurrency })
    }
]

/**Vista del detalle de un REP */
class RepViewNoRx extends React.PureComponent<Props> {
    value = (x: Props) => x.value;
    getField = kea.formfields(() => ({
        ...this.props,
        readonly: true
    }));

    onDescargarArchivo = async (func: (id: number) => Promise<string>, extension: string) => {
        const data = await func(this.props.value.IdRegistro);
        kea.download(data, "REP " + this.props.value.SerieFolio + "." + extension);
    }

    onXml = async () => await this.onDescargarArchivo(resources.Rep.ObtenerXML, "xml");
    onPdf = async () => await this.onDescargarArchivo(resources.Rep.ObtenerPDF, "pdf");

    render() {
        const Text = this.getField(kea.Text);
        const Number = this.getField(kea.Number);
        const Date = this.getField(kea.DateTime);
        const SiNo = this.getField(selectores.SiNo);
        const Receptor = this.getField(ReceptorFactura);
        const BancoSelector = this.getField(selectores.Banco);
        const x = this.props.value;
        return (
            <div>
                <kea.Title titulo="REP"
                    onRegresar={() => history.go("../")}
                >
                    <kea.Button style="success" onClick={this.onXml}>
                        XML
                    </kea.Button>
                    <kea.Button style="danger" onClick={this.onPdf}>
                        PDF
                    </kea.Button>
                </kea.Title>
                {kea.autogrid(3, [
                    <Text field="SerieFolio" label="Folio" />,
                    <SiNo field="Cancelacion" label="Cancelado?" />,
                    <Text field="NombreCliente" label="Cliente" />,
                    <Text field="FechaCreacion" label="Fecha de creación" />,
                    <Text field="NombreFormaPago" label="Forma de pago" />,
                    <Number field="ImportePagado" label="Importe" format="currency" />,
                    <Text field="FoliosRepSustituidos" label="Folio REP. sust." />,
                    <Text field="UUID" />,
                    <Date field="FechaTimbrado" />,
                    <kea.DateTime value={x.Pago.FechaPago} label="Fecha de pago" readonly />,
                    <Text field="NombreSucursal" />,
                    <BancoSelector field="IdBanco" label="Banco receptor" />
                ])}

                <Receptor field="ReceptorREP" />

                <kea.Title size="h4" titulo="Facturas" />
                <kea.Grid2 items={this.props.value.FacturasRelacionadas} columnas={facRelCols} />
            </div>
        )
    }
}

export const RepView = componentToRx(RepViewNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/reps/edit/form.tsx